exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio-boxs[data-v-d6f15e90] .el-checkbox__label{font-size:14px !important}.title-tips[data-v-d6f15e90]{font-size:12px;color:#999}", ""]);

// exports
